import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { getToken } from '../../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ClientesAdmin = () => {
  const [clientes, setClientes] = useState([]);
  const [clientesFiltrados, setClientesFiltrados] = useState([]);
  const [busqueda, setBusqueda] = useState('');

  const cargarClientes = async () => {
    const token = getToken();
    try {
      const res = await api.get('/admin/clientes', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const usuarios = res.data.usuarios || [];
      setClientes(usuarios);
      setClientesFiltrados(usuarios);
    } catch (err) {
      console.error('❌ Error al cargar clientes:', err);
      toast.error('Error al cargar los clientes');
    }
  };

  useEffect(() => {
    cargarClientes();
  }, []);

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    setClientes(prev =>
      prev.map(cliente => (cliente.id === id ? { ...cliente, [name]: value } : cliente))
    );
    setClientesFiltrados(prev =>
      prev.map(cliente => (cliente.id === id ? { ...cliente, [name]: value } : cliente))
    );
  };

  const guardarCambios = async (id, nombre, apellidos, email, telefono) => {
    const token = getToken();
    try {
      await api.put(
        `/admin/cliente/${id}`,
        { nombre, apellidos, email, telefono },
        {
          headers: { Authorization: `Bearer ${token}` }
        });
      toast.success('Cliente actualizado correctamente');
      cargarClientes();
    } catch (err) {
      console.error('❌ Error al actualizar cliente:', err);
      toast.error('Error al actualizar cliente');
    }
  };

  const eliminarCliente = async (id) => {
    const token = getToken();

    try {
      // Primer intento de eliminación
      await api.delete(`/admin/cliente/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Cliente eliminado');
      cargarClientes();
    } catch (err) {
      console.error('❌ Error al eliminar cliente:', err);

      // Verificar si el error es por citas futuras
      if (err.response?.status === 400 && err.response?.data?.tieneCitasFuturas) {
        const { citasFuturas, totalCitasFuturas } = err.response.data;

        // Formatear las citas para mostrar
        const listaCitas = citasFuturas.map(cita => {
          const fecha = new Date(cita.fecha).toLocaleDateString('es-ES');
          return `  • ${fecha} a las ${cita.hora_inicio} - ${cita.servicio}`;
        }).join('\n');

        const mensaje = `⚠️ Este cliente tiene ${totalCitasFuturas} cita(s) futura(s):\n\n${listaCitas}\n\n¿Estás seguro de eliminar este cliente?\n\n❗ IMPORTANTE: Las citas futuras se ELIMINARÁN permanentemente.\nLas citas pasadas se mantendrán como "(Usuario eliminado)".`;

        const confirmar = window.confirm(mensaje);

        if (confirmar) {
          try {
            // Segundo intento con confirmación
            await api.delete(`/admin/cliente/${id}?confirmDelete=true`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Cliente eliminado correctamente');
            cargarClientes();
          } catch (err2) {
            console.error('❌ Error al eliminar cliente (confirmado):', err2);
            toast.error('Error al eliminar el cliente');
          }
        }
      } else {
        // Otro tipo de error
        const mensajeError = err.response?.data?.mensaje || 'Error al eliminar el cliente';
        toast.error(mensajeError);
      }
    }
  };

  const actualizarContrasena = async (id) => {
    const nuevaContrasena = prompt('Introduce la nueva contraseña:');
    if (!nuevaContrasena) return;

    if (nuevaContrasena.length < 6) {
      toast.warning('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    const token = getToken();
    try {
      await api.put(
        `/admin/cliente/${id}/contrasena`,
        { contrasenaNueva: nuevaContrasena },
        {
          headers: { Authorization: `Bearer ${token}` }
        });
      toast.success('Contraseña actualizada correctamente');
    } catch (err) {
      console.error('❌ Error al actualizar la contraseña:', err);
      toast.error('Error al actualizar la contraseña');
    }
  };

  const filtrarClientes = (valor) => {
    setBusqueda(valor);
    const valorLower = valor.toLowerCase();

    const filtrados = clientes.filter(cliente => {
      const nombreCompleto = `${cliente.nombre} ${cliente.apellidos}`.toLowerCase();
      return (
        nombreCompleto.includes(valorLower) ||
        cliente.telefono.includes(valorLower)
      );
    });

    setClientesFiltrados(filtrados);
  };


  return (
    <main className="site-width">
      <div className="texto-dashboard">
        <h1>Gestión de clientes</h1>
        <p>Modifica y elimina clientes registrados.</p>
        <p style={{ marginTop: '10px', fontWeight: '600', fontSize: '14px', color: '#244480' }}>
          Total clientes registrados: {clientes.length}
        </p>
      </div>

      <div className="grid-clientes-admin">


        {/* Buscador */}
        <div className="buscador-clientes">
          <input
            type="text"
            placeholder="Búsqueda por nombre y apellidos o teléfono..."
            value={busqueda}
            onChange={(e) => filtrarClientes(e.target.value)}
          />
        </div>

        {/* Tabla de clientes */}
        <div className="overflow-tabla">
          <div className="tabla-clientes">
            <div className="tabla-header">
              <div>Nombre</div>
              <div>Apellidos</div>
              <div>Email</div>
              <div>Teléfono</div>
              <div>Acciones</div>
            </div>

            {clientesFiltrados.map(cliente => (
              <div key={cliente.id} className="tabla-row">
                <div>
                  <input
                    type="text"
                    name="nombre"
                    value={cliente.nombre}
                    onChange={(e) => handleChange(e, cliente.id)}
                    placeholder="Nombre"
                  />
                </div>
                <div>
                  <input
                    type="text"
                    name="apellidos"
                    value={cliente.apellidos}
                    onChange={(e) => handleChange(e, cliente.id)}
                    placeholder="Apellidos"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    value={cliente.email}
                    onChange={(e) => handleChange(e, cliente.id)}
                    placeholder="Email"
                  />
                </div>
                <div>
                  <input
                    type="text"
                    name="telefono"
                    value={cliente.telefono}
                    onChange={(e) => handleChange(e, cliente.id)}
                    placeholder="Teléfono"
                  />
                </div>
                <div className="acciones-clientes">
                  <button
                    className="boton-guardar"
                    onClick={() =>
                      guardarCambios(cliente.id, cliente.nombre, cliente.apellidos, cliente.email, cliente.telefono)
                    }
                  >
                    <img src="/images/confirmar.svg" alt="Guardar" />
                  </button>
                  <button
                    className="boton-eliminar"
                    onClick={() => eliminarCliente(cliente.id)}
                  >
                    <img src="/images/cancelar.svg" alt="Guardar" />
                  </button>
                  <button
                    className="boton-actualizar-contrasena"
                    onClick={() => actualizarContrasena(cliente.id)}
                  >
                    Cambiar contraseña
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </main>
  );
};

export default ClientesAdmin;
